$(document).on('click', '.translator', function() {
    $(this).toggleClass('active');
});
